export default __webpack_public_path__ + "static/media/key-pressed.86bc8995.svg";